import {forwardRef, type SVGProps} from 'react';

export const VerticalLineIcon = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => (
    <svg xmlns='http://www.w3.org/2000/svg' stroke='currentColor' viewBox='0 0 1 16' {...props} ref={ref}>
        <line x1='0.5' y1='0.5' x2='0.5' y2='15.5' strokeLinecap='round'/>
    </svg>
));
